import Wrap from '../ui/Wrap'
import Button from '../ui/Button'

const BACKERS = [
  { mark: 'EWOR', caption: 'Fellowship' },
  { mark: 'Google', caption: 'GenAI Program' },
  { mark: 'NVIDIA', caption: 'Inception Program' },
]

const WORKLOADS = [
  'Large-scale inference',
  'Continuous agents',
  'Massive document intelligence',
  'Long-running reasoning',
  'High concurrency',
  'Private AI',
  'Sovereign workloads',
  'Compute-constrained AI',
  'Agentic coding',
  'Customer-facing AI products',
]

export default function FinalCta() {
  return (
    <section id="reserve" className="bg-[var(--paper)] border-t border-[var(--line)] py-28 text-center md:py-44">
      <Wrap>
        <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">
          Stop rationing intelligence
        </div>
        <h2 className="mx-auto mt-9 max-w-[15ch] text-[clamp(2.3rem,4.7vw,3.5rem)] leading-[1.04] font-semibold tracking-[-0.035em]">
          Bring us the workload that matters most.
        </h2>
        <p className="mx-auto mt-8 max-w-[58ch] text-[1.125rem] leading-[1.68] text-[var(--ink-2)]">
          We're selecting enterprise and high-growth AI design partners with valuable production workloads that today's
          infrastructure forces them to ration.
        </p>

        <div className="mx-auto mt-16 max-w-[720px]">
          <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">Ideal workloads</div>
          <p className="mt-6 text-[1.05rem] leading-[2.1] text-[var(--ink-2)]">{WORKLOADS.join('\u00a0· ')}</p>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-3.5">
          <Button variant="primary" href="#" data-reserve>
            Bring us your workload &rarr;
          </Button>
          <Button
            variant="ghost"
            href="mailto:sales@nexlayer.com?subject=Liquid%20Brain%20-%20talk%20to%20us"
            data-talk-to-us
          >
            Talk to an AI Solutions Engineer &rarr;
          </Button>
        </div>
        <p className="mt-8 font-mono text-[12px] tracking-[0.06em] text-[var(--faint)]">
          Unlimited tokens &middot; Unlimited context &middot; Private by design &middot; Predictable capacity
        </p>

        <div className="mt-28">
          <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">
            Backed by leaders from
          </div>
          <div className="mt-9 flex flex-wrap items-end justify-center gap-10 md:gap-20">
            {BACKERS.map((b) => (
              <div key={b.mark} className="flex flex-col items-center gap-2.5">
                <span className="text-[1.35rem] font-medium tracking-[-0.02em] text-[var(--ink-2)]">{b.mark}</span>
                <span className="font-mono text-[11px] tracking-[0.06em] text-[var(--faint)]">{b.caption}</span>
              </div>
            ))}
          </div>
        </div>
      </Wrap>
    </section>
  )
}
